export interface Chip<K extends string> {
  cheie: K
  eticheta: string
  numar?: number
}

/**
 * Filtrul principal al unei liste, ca chip-uri cu numar — in locul unui meniu derulant: se vede
 * dintr-o privire cate sunt in fiecare stare, iar alegerea e un singur clic.
 */
export function ChipuriFiltru<K extends string>({
  chipuri,
  ales,
  onAlege,
  eticheta = 'Filtru',
}: {
  chipuri: Chip<K>[]
  ales: K
  onAlege: (k: K) => void
  eticheta?: string
}) {
  return (
    <div role="group" aria-label={eticheta} className="flex flex-wrap gap-1.5">
      {chipuri.map((c) => {
        const activ = c.cheie === ales
        return (
          <button
            key={c.cheie}
            type="button"
            aria-pressed={activ}
            onClick={() => onAlege(c.cheie)}
            className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-[12.5px] transition ${
              activ
                ? 'border-b4l-text bg-b4l-text text-b4l-surface'
                : 'border-b4l-border bg-b4l-surface hover:bg-b4l-bg-soft'
            }`}
          >
            {c.eticheta}
            {c.numar != null && (
              <span className={`tabular-nums ${activ ? 'opacity-70' : 'text-b4l-text-dim'}`}>
                {c.numar.toLocaleString('ro-RO')}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
